export default "__VITE_ASSET__a0218af4__"